<script setup lang="ts">
import type { CmsUiTimeline } from './uiCmsTimeline';
import UiCmsTimelineItem from './UiCmsTimelineItem.vue';

defineOptions({
  name: 'UiCmsTimeline',
});

defineProps({
  data: {
    type: Object as PropType<CmsUiTimeline>,
    required: true,
  },
});
</script>

<template>
  <div class="ui-cms-timeline__wrapper">
    <div v-storyblok-editable="data" class="ui-cms-timeline">
      <UiCmsTimelineItem v-for="historyItem in data.items" :key="historyItem._uid" :data="historyItem" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-cms-timeline__wrapper {
  padding: 0 $ui-global-padding;
}
.ui-cms-timeline {
  display: grid;
  grid-auto-flow: row;
  row-gap: $space40;
  position: relative;
  overflow-x: hidden;

  &::before {
    position: absolute;
    content: '';
    width: 1px;
    background: $black;
    height: 100%;
    left: 228px;

    @include apply-upto(small) {
      left: 5px;
    }
  }
}
</style>
